import { Component, Host, Prop, State, h } from '@stencil/core';
import { TrackingService } from '../../services/tracking';
import { TrackingObjectBuilder } from '../../services/tracking/tracking-object-builder';
import { Multilink } from '../types/link.types';
import { StringService } from '../../services';

@Component({
  tag: 'rcm-wrapper-link',
  styleUrl: 'rcm-wrapper-link.scss',
  shadow: true,
})
export class RcmWrapperLink {
  @Prop() link: string | Multilink;

  @Prop() trackingLinkText: string;

  @Prop() parentComponent: string;

  @Prop() isSocialLink?: boolean = false;

  @Prop() linkTitle: string;

  @Prop() ariaLabel: string;

  @State() private parsedLink?: Multilink;

  public constructor() {
    this.handleClick = this.handleClick.bind(this);
  }

  async componentWillLoad() {
    this.parsedLink = StringService.parseLink(this.link);
  }

  handleClick(e) {
    if (this.isSocialLink && 'share' in window.navigator) {
      e.preventDefault();

      navigator
        .share({
          title: document.title,
          url: window.location.href,
          // eslint-disable-next-line @typescript-eslint/no-empty-function
        })
        .catch(() => {});
    }

    TrackingService.push(
      new TrackingObjectBuilder()
        .forLinkClick({
          clickText: this.trackingLinkText,
          clickUrl: this.parsedLink.src,
          parentComponent: this.parentComponent,
        })
        .build(),
    );
  }

  render() {
    const href = StringService.normalizeLink(this.parsedLink.src);

    return (
      <Host>
        <a
          href={href}
          target={this.parsedLink.target}
          onClick={this.handleClick}
          {...(this.linkTitle !== undefined ? { title: this.linkTitle } : {})}
          aria-label={this.ariaLabel ?? ''}
        >
          <slot></slot>
        </a>
      </Host>
    );
  }
}
